import { useAuth } from '../contexts/AuthContext';

/**
 * O que o perfil ativo FAZ na agenda (RN-115d). `schedule` é ver a agenda; estas seis são as ações.
 * A tela só esconde ou trava — quem decide é o servidor, que confere as mesmas permissões.
 * O alcance (própria agenda x clínica toda) continua vindo de writeScope/dataScope.
 */
export interface SchedulePermissions {
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  /** Só confirmação e presença (também o "Atendimento realizado" da evolução) */
  canAttendance: boolean;
  canBlockEdit: boolean;
  canBlockDelete: boolean;
  /** Abre o agendamento existente para alterar algo (edição completa ou só status) */
  canOpenForChange: boolean;
}

export const useSchedulePermissions = (): SchedulePermissions => {
  const { user } = useAuth();
  const pages = user?.allowedPages ?? [];
  const has = (page: string) => pages.includes(page);
  const canEdit = has('schedule-edit');
  const canAttendance = has('schedule-attendance');
  return {
    canCreate: has('schedule-create'),
    canEdit,
    canDelete: has('schedule-delete'),
    canAttendance,
    canBlockEdit: has('schedule-block-edit'),
    canBlockDelete: has('schedule-block-delete'),
    canOpenForChange: canEdit || canAttendance,
  };
};
